import React from 'react'
import ReactModal from 'react-modal'

export default function MediumModal({children, bgBlur=false }) {
  let bgStyle = bgBlur ? {
    backdropFilter: 'blur(8px)',
    backgroundColor: 'rgba(255,255,255,0.34)',
    boxShadow: 'inset 0 -6px 63px 0 rgba(255,255,255,0.43)',
  } : {}

  return (
    <ReactModal
      isOpen
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          border: 'none',
          maxWidth: '550px',
          width:'50% !important',
          borderRadius: '20px',
          marginRight: '-50%',
          boxShadow: '0 0 10px #AAAAAA',
          transform: 'translate(-50%, -50%)',
          // ...bgStyle
        },
      }}>
      <div className='d-flex flex-column px-4'>
        <div className='row justify-content-center align-items-center'>
          <div className='col-12'>{children}</div>
        </div>
      </div>
    </ReactModal>
  )
}
